/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';

export const billRateStyles = makeStyles()(theme => ({
  middleText: {
    fontSize: '14px',
    fontWeight: 500,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
}));
